import { endpoint } from '@library/endpoint'

import { fetch } from 'utils/fetch'

import {
  AuthPaymentReqData,
  SignupPaymentReqData,
  SignupPaymentProvider,
} from './models/CheckoutTypes'

const getPaymentsEndpoint = () => `${endpoint('payments')}/payments/`

const HEADERS = {
  'Content-Type': 'application/json',
}

function authPayment(reqData: AuthPaymentReqData, sessionId: string) {
  return fetch<{ data: { responsePayload: { redirectLink: string } } }>(
    null,
    `${getPaymentsEndpoint()}payment-auth?session_id=${sessionId}`,
    reqData,
    'POST',
    undefined,
    HEADERS,
  )
}

function checkPayment(checkoutSessionId: string, goustoSessionId: string) {
  return fetch<{ data: { approved: boolean; sourceId: string } }>(
    null,
    `${getPaymentsEndpoint()}payments/${checkoutSessionId}?session_id=${goustoSessionId}`,
    undefined,
    'GET',
    undefined,
    HEADERS,
  )
}

function signupPayment(
  reqData: SignupPaymentReqData,
  provider: SignupPaymentProvider,
  sessionId: string,
) {
  return fetch(
    null,
    `${getPaymentsEndpoint()}signup-payments?provider=${provider}&session_id=${sessionId}`,
    reqData,
    'POST',
    undefined,
    HEADERS,
  )
}

function get3DSCompliantToken(goustoRef: string) {
  return fetch(
    null,
    `${getPaymentsEndpoint()}3ds-compliant/${goustoRef}`,
    {},
    'GET',
    undefined,
    HEADERS,
  )
}

export { authPayment, checkPayment, signupPayment, get3DSCompliantToken }
